logoContainer.$inject = ["API_URL", "$rootScope", "$timeout"];
angular.module('calendarApp').directive('logoContainer', logoContainer);

function logoContainer(API_URL, $rootScope, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    template: '<a ng-href="/{{orgID}}" style="max-width: {{logoWidth}};" class="logo-image"><img ng-if="logoSrc" ng-src="{{logoSrc}}"/></a>',
    link: function link(scope, elem, attrs) {
      scope.orgID = smooth.orgid;
      scope.logoSrc = smooth.calendarSettings.logo && smooth.calendarSettings.logo.display && smooth.calendarSettings.logo.display.url;
      scope.logoWidth = smooth.calendarSettings.logowidth ? smooth.calendarSettings.logowidth : 1000;
      scope.logoWidth = smooth.calendarSettings.logowidth ? "".concat(smooth.calendarSettings.logowidth, "px") : '22%';
    }
  };
}